// import axios from './axios'
import gun from './gun'
import medicRegistrationJson from '../contracts/medicRegistration'
class MedicsManager {


    static async  GetMedicRegistrationContract(id) {
        console.log(window.web3.eth)
        let LoginContract = new  window.web3.eth.Contract(medicRegistrationJson.abi,id, { from: window.web3.eth.defaultAccount});
        return LoginContract
    }
    static GetMedics() {
        return new Promise((resolve) => {
            // axios.get(`/api/medics?page=${page}`).then((data) => {
            //     console.log(data)
            //     resolve(data.data)
            // })

            resolve(gun.get('medics').map())
        })
    }

    static CreateMedic() {
        return new Promise((resolve) => {
            // axios.post('/api/medics', medic).then(() => {
            //     resolve()
            // })
            // gun.get('medics').get(medic.wallet).put(medic)
            resolve()
        })
    }

    static GetMedic(id) {
        return new Promise((resolve) => {
            // axios.get(`/api/medic/${id}`).then((data) => {
            //     resolve(data.data)
            // })

            resolve(gun.get('medics').get(id))
        })
    }
}

export default MedicsManager